var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAcca = function SvgIconAcca(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.917 37.333C23.037 37.333 28 32.37 28 26.249c0-6.12-4.962-11.083-11.083-11.083S5.833 20.128 5.833 26.249c0 6.122 4.963 11.084 11.084 11.084Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 28H21a2.333 2.333 0 0 0-2.333 2.333v17.5A2.333 2.333 0 0 0 21 50.167h17.5a2.333 2.333 0 0 0 2.333-2.334v-17.5A2.333 2.333 0 0 0 38.5 28Z",
    fill: "#3987F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m49.648 17.695-17.5-11.667A1.166 1.166 0 0 0 30.332 7v23.334a1.166 1.166 0 0 0 1.815.971l17.5-11.667a1.166 1.166 0 0 0 0-1.942Z",
    fill: "#FFC82A"
  })));
};
export default SvgIconAcca;